define('models/manual_payment',['require','backbone'],function(require){

    var Backbone = require('backbone');

    return Backbone.Model.extend({
        url : function() {
            // set the endpoint for restful api for articles
            return this.id ? ( App.Config.apiBase + 'manual-payments/' + this.id + '/' ) :
                ( App.Config.apiBase + 'manual-payments/' );
        },

        defaults: function () {
            return {
                reseller: null,
                customer: null,
                payment_amount: 0,
                payment_schedule: 1,
                payment_count: 1,
                credit_card: '',
                transactions: [],
                currency: '',
                created: ''
            };
        }
    });
});
